import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const toolsPartsIssuedTodo = createAsyncThunk('toolsPartsIssued', async ({ navigate } = {}) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'tools_parts_issue/store_details',
            params: { ctype: 'R' },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const toolsPartsIssuedSlice = createSlice({
    name: 'toolsPartsIssued',
    initialState: { data: [] },
    reducers: {
        clearToolsPartsIssued: (state) => { state.data = [] },
    },
    extraReducers: (builder) => {
        builder.addCase(toolsPartsIssuedTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(toolsPartsIssuedTodo.rejected, () => { })
    }
})

export const { clearToolsPartsIssued } = toolsPartsIssuedSlice.actions;
export default toolsPartsIssuedSlice.reducer;
